import AddTechnicalAssistanceModal from './add-technical-assistance-modal.vue'
export default AddTechnicalAssistanceModal
